import { useEffect, useState } from 'react';
import { FieldValues, UseFormGetValues } from 'react-hook-form';
import { handleKeyDown } from '@msc-b2c/shared-utils/keyboardUtils';
import styles from './optionsbox.module.scss';

export function OptionsBox({
  relatedFieldName,
  options,
  getValues,
  onSelection,
  isVisible = true,
}: {
  relatedFieldName: string;
  options: { label: string; value: string }[];
  getValues: UseFormGetValues<FieldValues>;
  onSelection?: (...args: any[]) => void;
  isVisible?: boolean;
}) {
  const [selectedOption, setSelectedOption] = useState<string>();
  const [shouldShowOptions, setShouldShowOptions] = useState<boolean>(isVisible);

  useEffect(() => {
    setShouldShowOptions(
      isVisible &&
        options.length > 0 &&
        !options.some(
          (option) => option.value?.toLowerCase() === getValues(relatedFieldName)?.toLowerCase()
        )
    );
  }, [isVisible, options, selectedOption]);

  const handleSelection = (value: string) => {
    setSelectedOption(value);

    if (onSelection) onSelection(value);
  };

  return (
    shouldShowOptions && (
      <div className={styles['cmp-options-box']}>
        <ul className={styles['cmp-options-box__options']}>
          {options.map((option, index) => (
            <li
              key={`option-${index}`}
              className={styles['cmp-options-box__option']}
              value={option.value}
              onClick={() => handleSelection(option.value)}
              onKeyDown={(e) => handleKeyDown(e, () => handleSelection(option.value))}
              tabIndex={0}
            >
              {option.label}
            </li>
          ))}
        </ul>
      </div>
    )
  );
}
